import RequestStatusDatatable from "@/components/Requests/RequestStatusDatatable.vue";

// This grouping route never renders anything itself (no `components`) - it exists
// only so the "status" child below can live in the route tree. The final URL is
// the absolute child path "/request/status", chosen deliberately instead of a
// relative "request" + "status" pair (like ProjectRoutes) because "/request" is
// already claimed by RequestsRoutes.ts (the ticket list at /request/list).
export default [{
    path: 'request-status-root',
    name: 'Request Status Root',
    redirect: "/request/status",
    meta: {
        requiresAuth: true
    },
    children: [
        {
            path: "/request/status",
            name: "Request Status",
            components: {
                page: RequestStatusDatatable
            }
        }
    ]
}];
